export default __webpack_public_path__ + "images/6d2ed1c72da0caf65de1d57bab4e41fa.jpg";